(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("scrollSmooth", [], factory);
	else if(typeof exports === 'object')
		exports["scrollSmooth"] = factory();
	else
		root["scrollSmooth"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition